import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import {
    FaTasks,
    FaCheckCircle,
    FaDollarSign,
    FaTimesCircle,
    FaCommentDots,
    FaClock,
    FaEnvelopeOpen,
} from 'react-icons/fa';
import DashboardStatisticCard from './DashboardStatisticCard';
import DashboardRatingStars from './DashboardRatingStars';
import { DASHBOARD_CARD_STYLES, DASHBOARD_ROUTES } from '../utils/dashboardConstants';

const DashboardStatisticCardGroup = ({ stats }) => {
    return (
        <Row className="mb-1">
            <Col lg={3} md={3} sm={6} xs={12} className="mb-4">
                <DashboardStatisticCard
                    title="Accepted Bookings"
                    value={stats.bookings.total}
                    change={`+${stats.bookings.increase}`}
                    description="in the last 30 days"
                    increaseClass={DASHBOARD_CARD_STYLES.acceptedBookings.increaseClass}
                    icon={<FaCheckCircle className="text-xs icon-bookings-year" />}
                    bgClass={DASHBOARD_CARD_STYLES.acceptedBookings.bgClass}
                />
            </Col>

            <Col lg={3} md={3} sm={6} xs={12} className="mb-4">
                <DashboardStatisticCard
                    title="Total Income"
                    value={stats.income.total}
                    change={`+${stats.income.increase}`}
                    description="in the last 30 days"
                    increaseClass={DASHBOARD_CARD_STYLES.income.increaseClass}
                    icon={<FaDollarSign className="text-xs icon-income-year" />}
                    bgClass={DASHBOARD_CARD_STYLES.income.bgClass}
                />
            </Col>

            <Col lg={3} md={3} sm={6} xs={12} className="mb-4">
                <DashboardStatisticCard
                    title="Cancelled Bookings"
                    value={stats.cancels.total}
                    change={`+${stats.cancels.increase}`}
                    description="in the last 30 days"
                    increaseClass={DASHBOARD_CARD_STYLES.cancelledBookings.increaseClass}
                    icon={<FaTimesCircle className="text-xs icon-cancelled-year" />}
                    bgClass={DASHBOARD_CARD_STYLES.cancelledBookings.bgClass}
                />
            </Col>

            <Col md={3} sm={6} xs={12} className="mb-4">
                <DashboardStatisticCard
                    title="Customer Reviews"
                    value={<DashboardRatingStars rating={stats.reviews.total} />}
                    description={`Low-rating share: ${stats.reviews.complainPercent}%`}
                    icon={<FaCommentDots className="text-xs icon-reviews-year" />}
                    bgClass={DASHBOARD_CARD_STYLES.reviews.bgClass}
                />
            </Col>

            <Col md={3} sm={6} xs={12} className="mb-4">
                <NavLink to={DASHBOARD_ROUTES.BOOKINGS_IN_PROGRESS} className="block-link">
                    <DashboardStatisticCard
                        title="In-Progress Bookings"
                        value={stats.inProgressBookings.total}
                        description={`Latest end date: ${stats.inProgressBookings.latestRentalDate || '-'}`}
                        icon={<FaTasks className="text-xs icon-bookings-progress" />}
                        bgClass={DASHBOARD_CARD_STYLES.inProgressBookings.bgClass}
                    />
                </NavLink>
            </Col>

            <Col md={3} sm={6} xs={12} className="mb-4">
                <NavLink to={DASHBOARD_ROUTES.BOOKINGS_PENDING} className="block-link">
                    <DashboardStatisticCard
                        title="Pending Bookings"
                        value={stats.pendingBookings.total}
                        description={`Next booking date: ${stats.pendingBookings.closestExpiryDate || '-'}`}
                        icon={<FaClock className="text-xs icon-bookings-pending" />}
                        bgClass={DASHBOARD_CARD_STYLES.pendingBookings.bgClass}
                    />
                </NavLink>
            </Col>

            <Col md={3} sm={6} xs={12} className="mb-4">
                <NavLink to={DASHBOARD_ROUTES.REQUESTS_IN_PROGRESS} className="block-link">
                    <DashboardStatisticCard
                        title="Open Requests"
                        value={stats.inProgressRequests.total}
                        description={
                            stats.inProgressRequests.newReply > 0
                                ? `${stats.inProgressRequests.newReply} new repl${stats.inProgressRequests.newReply > 1 ? 'ies' : 'y'}`
                                : 'Currently being handled'
                        }
                        icon={<FaEnvelopeOpen className="text-xs icon-requests-progress" />}
                        bgClass={DASHBOARD_CARD_STYLES.inProgressRequests.bgClass}
                    />
                </NavLink>
            </Col>
        </Row>
    );
};

export default DashboardStatisticCardGroup;